"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Tab } from "@headlessui/react";

import EndeksaLogo from "assets/svg/endeksa_red.svg";

import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";
import PriceIndexGraphic from "components/listing-detail/price-index-graphic";
import PreviousPriceTable from "./previous-price-table";
import JetFirsatBannerPriceIndex from "components/listing-detail/jetfirsat-banner-price-index";

import { priceHistoryDescriptionText } from "@/mock/endeksa";

import styles from "./styles.module.css";

const PreviousPrices = ({ min, max, current, isJetFirsatListing, townName, priceHistory }) => {
  const [tabTitle, setTabTitle] = useState(["Fiyat Endeksi", "Fiyat Geçmişi"]);

  const heightForThreeLineVisible = 55;
  const priceHistoryDescription = isJetFirsatListing
    ? priceHistoryDescriptionText.jetFirsat
    : priceHistoryDescriptionText.notJetFirsat;

  const isVisiblePriceIndex = (maxParameter, currentParameter) => {
    return currentParameter <= maxParameter;
  };

  useEffect(() => {
    if (priceHistory) {
      const isPriceIndexExist = isVisiblePriceIndex(max, current);

      const newTabTitle =
        priceHistory?.length > 0
          ? isPriceIndexExist
            ? ["Fiyat Endeksi", "Fiyat Geçmişi"]
            : ["Fiyat Geçmişi"]
          : isPriceIndexExist
          ? ["Fiyat Endeksi"]
          : [];
      setTabTitle(newTabTitle);
    }
  }, [priceHistory]);

  return (
    <>
      {(priceHistory?.length > 0 || (min && max)) && (
        <div className={styles.wrapper} id="fiyat-analizi" data-scroll-selector>
          <Title>{tabTitle?.length === 2 ? "Fiyat Bilgisi" : tabTitle[0]}</Title>
          <Tab.Group>
            <Tab.List className={styles.tabList}>
              {tabTitle?.map((item, index) => (
                <Tab
                  key={index}
                  className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
                >
                  {item}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className={styles.tabPanels}>
              {tabTitle?.includes("Fiyat Endeksi") && (
                <Tab.Panel>
                  {isJetFirsatListing ? (
                    <JetFirsatBannerPriceIndex />
                  ) : (
                    <span className={styles.priceIndexInfo}>
                      {townName} - Bu ilan için bölgesindeki diğer ilanlar ve özellikler dikkate alınarak tahmini bir
                      fiyat hesaplaması yapılmıştır.
                    </span>
                  )}
                  <div>
                    <PriceIndexGraphic min={min} max={max} current={current} isJetFirsatListing={isJetFirsatListing} />
                  </div>
                  <MoreContent defaultHeight={heightForThreeLineVisible}>
                    <span className={styles.priceIndexLastInfo}>
                      {priceHistoryDescription.beforeLinkText}
                      <a
                        target="_blank"
                        href="https://www.endeksa.com/en/"
                        className={styles.endeksaLogo}
                        rel="noreferrer"
                      >
                        <EndeksaLogo />
                      </a>
                      {priceHistoryDescription.afterLinkText}
                    </span>
                  </MoreContent>
                </Tab.Panel>
              )}
              {tabTitle?.includes("Fiyat Geçmişi") && (
                <Tab.Panel>
                  <div>
                    <MoreContent defaultHeight={215}>
                      <PreviousPriceTable priceHistory={priceHistory} />
                    </MoreContent>
                  </div>
                </Tab.Panel>
              )}
            </Tab.Panels>
          </Tab.Group>
        </div>
      )}
    </>
  );
};

PreviousPrices.propTypes = {
  listingId: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  current: PropTypes.number,
  isJetFirsatListing: PropTypes.bool,
  townName: PropTypes.string,
};

export default PreviousPrices;
